import type { SimSwapVerificationState } from './simSwapReadiness';

export function canSendSimSwapVerification(
  verification: SimSwapVerificationState | null | undefined,
  busy: boolean,
): boolean {
  return (
    !busy &&
    verification?.initiationAvailable !== false &&
    ['REQUIRED', 'PENDING', 'FAILED', 'EXPIRED', 'CONSUMED'].includes(
      verification?.status ?? '',
    )
  );
}

/** A failed delivery can still create a run; always reload both server views. */
export async function sendAndRefreshSimSwapVerification<T>(
  send: () => Promise<T>,
  refreshReadiness: () => Promise<unknown>,
  refreshMessages: () => Promise<unknown>,
): Promise<T> {
  try {
    return await send();
  } finally {
    // Refreshers own their error UI. A read failure must not turn a successful
    // send into a retry instruction and invalidate the customer's first link.
    await Promise.allSettled([refreshReadiness(), refreshMessages()]);
  }
}
